import { FormValues } from 'website/components/MakeModelYearForm/hook/validator'

export const configureStoreData = (values: FormValues): Pick<Store.TradeInVehicleState, 'make' | 'model' | 'year'> => ({
  make: values.make?.name ?? '',
  model: values.model?.name ?? '',
  year: values.year?.id ?? null
})
